import {
  SoundOffOutline18Icon,
  SoundOnOutline18Icon,
} from "@vygruppen/spor-icon-react";
import { MuteHistoryEntry } from "api/dropsLocalStorage";
import { parseISO } from "date-fns";
import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { FC, Fragment } from "react";
import { Flex, StaticCard, Text } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { formatMeasureCardDateTimeString } from "shared/utils/dateTimeUtils";
import { Semantics } from "shared/utils/semantics";

type MuteHistoryProps = {
  muteHistory: MuteHistoryEntry[];
  semantics: Semantics;
};

export const MuteHistory: FC<MuteHistoryProps> = ({
  muteHistory,
  semantics,
}) => {
  const theme = useThemeSemantic(semantics);

  if (!muteHistory.length) return null;

  return (
    <Flex flexDirection="column">
      {muteHistory.map((entry, index) => {
        const date = parseISO(entry.timestamp);
        const isLastElement = index === muteHistory.length - 1;

        const Icon =
          entry.action === "muted"
            ? SoundOffOutline18Icon
            : SoundOnOutline18Icon;

        return (
          // eslint-disable-next-line react/no-array-index-key -- no better alternative
          <Fragment key={index}>
            <StaticCard
              backgroundColor={theme.ghostSurface}
              borderRadius="xs"
              px={2}
              py={1.5}
            >
              <Flex alignItems="center" gap={1}>
                <Icon color="text.tertiary" />

                <Text variant="sm" fontWeight="bold">
                  {entry.action === "muted" ? "Dempet" : "Fremhevet"}{" "}
                  {formatMeasureCardDateTimeString(date)}
                </Text>
              </Flex>

              {entry.reason && (
                <Text variant="sm" color="text.tertiary">
                  {entry.reason}
                </Text>
              )}
            </StaticCard>

            {!isLastElement && (
              <DashedLine strokeDasharray="3 6" color={theme.ghostSurface} />
            )}
          </Fragment>
        );
      })}
    </Flex>
  );
};
